import React, { useContext } from "react";
import { FilterContext } from "../../context/Filter";
import { useQuery } from "@tanstack/react-query";
import { fetchallJobCardDetails } from "../spareSales/JC/Jckpi";

const Jccard = ({
  data,
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  data8,
  openAcAvgTat,
  openNonAcAvgTat,
  closedAcAvgTat,
  closedNonAcAvgTat,
  allAcAvgTat,
  allNonAcAvgTat
}) => {
  const accidentalCount =
    data?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const accidentalclosed =
    data4?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const accidentalopen =
    data2?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const nonaccidentalopen =
    data3?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const nonaccidentalclosed =
    data5?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const nonaccidentalall =
    data1?.aggregations?.groupby?.buckets?.all_docs?.doc_count;
  const invoiceacc = Number(
    data6?.aggregations?.Invoice_amount?.value || 0
  ).toFixed(2);
  const invoicenacc = Number(
    data7?.aggregations?.Invoice_amount?.value || 0
  ).toFixed(2);

  const { open } = useContext(FilterContext);

  return (
    <div className={` px-2 py-1  ${open ? ' justify-center justify-items-center' : ''}`}>
      <div className={`block justify-center   md:${open ? ' flex flex-wrap' : 'flex'} ${open ? ' justify-center justify-items-center' : ''} gap-3`}>

        {/* All Job Card */}
        <div className="w-96  sm:w-[calc(50%-8px)]  lg:w-[390px] border border-gray-300 bg-[#CFE2FF] opacity-95 rounded-xl p-2">
          <div className="text-center text-gray-700 text-md font-semibold mb-1">
            All Job Card
          </div>
          <hr className="border-gray-500 mb-3" />

          <div className="flex items-center justify-between">
            <div className="flex flex-col items-center flex-1">
              <p className="text-gray-600 text-sm font-semibold mb-2">Accidental</p>
              <div className="text-center">
                <p className="text-sm text-gray-500">
                  Total JC - {accidentalCount}
                </p>
                <p className="text-sm text-gray-500">Avg TAT - {Math.round(allAcAvgTat?.avg_tat_hrs)}</p>
              </div>
            </div>

            <div className="w-px h-16 bg-gray-500 mx-4"></div>

            <div className="flex flex-col items-center flex-1">
              <p className="text-gray-600 text-sm font-semibold mb-2">
                Non-Accidental
              </p>
              <div className="text-center">
                <p className="text-sm text-gray-500">
                  Total JC - {nonaccidentalall}
                </p>
                <p className="text-sm text-gray-500">Avg TAT - {Math.round(allNonAcAvgTat?.avg_tat_hrs)}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Closed Job Card */}
        <div className="w-full mt-2 md:mt-0 sm:w-[calc(50%-8px)] lg:w-[400px] border border-gray-300  opacity-95 bg-[#D1FADF] rounded-lg p-3">
          <div className="text-center font-semibold 1 text-gray-700">
            Closed Job Card
          </div>
          <hr className="border-gray-500 mb-3" />

          <div className="flex items-start justify-between">
            <div className="flex-1 text-center">
              <p className="font-semibold text-gray-600 mb-1 text-sm justify-center items-center">Accidental</p>
              <p className="text-sm text-center text-gray-500">Closed JC - {accidentalclosed}</p>
              <p className="text-sm text-center text-gray-500">Avg TAT - {Math.round(closedAcAvgTat?.avg_tat_hrs)}</p>
              <p className="text-sm text-center text-gray-500">Invoice Amt. - {invoiceacc}</p>
            </div>

            <div className="w-px h-16 bg-gray-500 mx-4"></div>

            <div className="flex-1 text-center">
              <p className="font-semibold text-center text-sm text-gray-600 mb-1">Non Accidental</p>
              <p className="text-sm text-center text-gray-500">Closed JC - {nonaccidentalclosed}</p>
              <p className="text-sm text-center text-gray-500">Avg TAT-{Math.round(closedNonAcAvgTat?.avg_tat_hrs)}</p>
              <p className="text-sm text-center text-gray-500">Invoice Amt. - {invoicenacc}</p>
            </div>
          </div>
        </div>

        {/* Open Job Card */}
        <div className="w-full mt-2 md:mt-0 sm:w-[calc(50%-8px)] lg:w-[350px] border border-gray-300  opacity-95 bg-[#FFF3CD] rounded-lg p-2">
          <div className="text-center mb-1 font-semibold text-gray-700">
            Open Job Card
          </div>
          <hr className="border-gray-500 mb-3" />

          <div className="flex items-start justify-between">
            <div className="flex-1 text-center">
              <p className="font-semibold text-sm text-center text-gray-600 mb-1">Accidental</p>
              <p className="text-sm text-gray-500 text-center">Open JC - {accidentalopen}</p>
              <p className="text-sm text-gray-500 text-center">Avg TAT- {Math.round(openAcAvgTat?.avg_tat_hrs)}</p>
            </div>

            <div className="w-px h-16 bg-gray-500 mx-4"></div>

            <div className="flex-1 text-center">
              <p className="font-semibold text-center  text-sm text-gray-600 mb-1">Non Accidental</p>
              <p className="text-sm text-center text-gray-500">Open JC - {nonaccidentalopen}</p>
              <p className="text-sm text-center text-gray-500">Avg TAT- {Math.round(openNonAcAvgTat?.avg_tat_hrs)}</p>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Jccard;